<template>
    <!-- begin:: Page -->
 
    
    <div id="iframeContent" class="m-grid__item m-grid__item--fluid m-wrapper" style="overflow:auto;">
      <div class="m-content" style="overflow: visible;" id="divContent">
        <!-- <iframe src="main.html" onload="Resize()" id="iframeContent" name="main" scrolling="no" width="100%"
          frameborder="0" class="m-scrollable m-scroller ps ps--active-y" data-scrollable="true"></iframe> -->
        <router-view />
      </div>
    </div>

</template>

<script>
  // import $ from 'jquery'
  export default {
    name: 'mainNav',
    data() {
      return {
        roleid: '',
        userid: '',
        rolelevel: '',
        tabMenu: '',
        roleMenu: '',
        username: '',
        truename: ''
      }
    },
    created() {
      window.JumpTo = this.JumpTo
    },
    methods: {     
      JumpToIndex: function() {

        this.$router.push(sessionStorage.getItem("menuUrl"))
      }
    },
    mounted: function() {
      var iframeContent = document.getElementById("iframeContent");
      var divContent = document.getElementById("divContent");
      if (window.XMLHttpRequest) {
        iframeContent.style.width = "100%";
      } else {
        iframeContent.style.width = (divContent.offsetWidth - 255) + "px";
      }
      divContent.style.height = (document.documentElement.clientHeight - 130) + "px";
      iframeContent.height = 0;
      iframeContent.height = (document.documentElement.clientHeight - 190) + "px";
      window.onresize = () => {
        return (() => {
          var iframeContent = document.getElementById("iframeContent");
          var divContent = document.getElementById("divContent");
          if (window.XMLHttpRequest) {
            iframeContent.style.width = "100%";
          } else {
            iframeContent.style.width = (divContent.offsetWidth - 255) + "px";
          }
          divContent.style.height = (document.documentElement.clientHeight - 130) + "px";
          iframeContent.height = 0;
          iframeContent.height = (document.documentElement.clientHeight - 190) + "px";
        })()
      }
      this.userid = sessionStorage.getItem('userid')
      this.rolelevel = sessionStorage.getItem('rolelevel')
      this.roleid = sessionStorage.getItem('roleid')
      this.username = sessionStorage.getItem('username')
      this.truename = sessionStorage.getItem('truename')
      
      this.JumpToIndex()
    }
  }
</script>

<style scoped="scoped">
  label {
    margin-bottom: 0;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  .el-table--medium td,
  .el-table--medium th {
    padding: 6px 0;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 220px;
  }
</style>
